import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Genre from '../../../domain/entities/Genre';

export default function reducer(
  state: {[key: number]: Genre} = {},
  action: AnyAction,
): {[key: number]: Genre} {
  switch (action.type) {
    case Types.IndexGenresSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Genre}, record: Genre) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
